import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-contacts-directory-page',
  templateUrl: './contacts-directory-page.component.html',
  styleUrls: ['./contacts-directory-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsDirectoryPageComponent {}
